import Backbone from "backbone";

// Constructor arguments
// - model                     : RemoteUserWords
// - el                        : select all checkbox
// - selectWholeCollectionView : SelectWholeCollectionView
const SelectAllView = Backbone.View.extend({
  events: {
    click: "clickSelectAll",
  },
  initialize: function () {
    const that = this;

    this.$input = this.$el.find("input");

    this.listenTo(this.model, "change", () => {
      if (that.model.get("wholePage")) {
        that.$input.prop("indeterminate", false).prop("checked", true);
      } else if (that.model.get("count") > 0) {
        that.$input.prop("indeterminate", true).prop("checked", true);
      } else {
        that.$input.prop("indeterminate", false).prop("checked", false);
      }
    });
  },
  clickSelectAll: function (event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.$input.prop("checked")) {
      this.model.clearSelection();
    } else {
      this.model.selectWholePage();
    }
  },
});

export default SelectAllView;
